module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAcCAMAAAAtIK2eAAAASFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACrhKybAAAAGHRSTlOzAKoHDaGblIF2a1UzKU8SimBaSj4hGXOzg1v8AAAAo0lEQVQ4y6XSSQ7DIBAF0R/ABoznKfe/aZRIdgzdDY5S67csPH7oX2x6Z63rhzs4KHxSfRk/cTaX8IxLIY87RHU5rOsY1zqDGyQ1Mm5BaiVsKoorI2APJs/jFWwrhwfFYzUw2EHIUbxAbEnxrmSs9gSPyDTGOCBbuOINhbYv1raErT7xhGLTgTuw0bVxTEyja4NMLNW8cQshujbIxGKVgcft/AtJgQT5twOQbQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trangle.png
// module id = Zan9
// module chunks = 54